<template>
  <v-row>
    <v-col cols="12" lg="12">
      <v-card>
        <v-toolbar flat>
          <v-col cols="12" class="px-0">
            <div class="d-flex align-center">
              <div class="text-left">
                <v-toolbar-title class="page-title">
                  Online Payment Validator
                </v-toolbar-title>
              </div>
              <div class="ml-auto">
                <!-- <v-btn
                  color="primary"
                  class="ml-auto"
                  :disabled="table.data.length <= 0"
                >
                  <download-csv :data="exportData" :name="`${fileName}.csv`">
                    <v-icon dense>mdi-download</v-icon>
                    Export
                  </download-csv>
                </v-btn> -->
              </div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-title>
          <v-row>
            <v-col cols="10">
              <v-file-input
                counter
                show-size
                small-chips
                truncate-length="50"
                accept=".csv"
                label="Upload CSV"
                @change="selectFile"
                ref="fileInput"
                clearable
                v-model="fileUpload"
              ></v-file-input>
            </v-col>
            <v-col cols="2" class="mt-3">
              <v-btn
                color="primary"
                block
                @click="upload"
                :disabled="submitted"
                :loading="submitted"
                
              >
                Upload
                <v-icon right>mdi-file-delimited</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <!-- <v-file-input
            counter
            show-size
            small-chips
            truncate-length="50"
            accept=".csv"
            label="Upload CSV"
          ></v-file-input> -->
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :items-per-page="10"
          :loading="table.loading"
          item-key="id"
          :search="search"
          loading-text="Loading... Please wait"
          class="elevation-1"
        >
          <template
            v-for="header in table.headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            {{ header.formatter(value) }}
          </template>

          <template v-slot:[`item.configured`]="{ item }">
            {{ item.configured ? "Yes" : "No" }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              x-small
              color="primary"
              class="mr-2"
              dark
              @click="viewRecord(item)"
            >
              View</v-btn
            >
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <OnuList ref="onuList" />
  </v-row>
</template>

<script>
// import moment from "moment";
import OnuList from "../dialogs/management/OnuList.vue";
import ShareableMethods from "@/mixins/ShareableMethods";
// import _ from "lodash";

export default {
  mixins: [ShareableMethods],
  components: {
    OnuList,
  },

  data() {
    return {
      fileUpload: null,
      exportData: [],
      fileName: "",
      submitted: false,

      currentFile: undefined,
      content: [],
      parsed: false,

      search: "",
      olt: "",
      table: {
        expanded: [],
        singleExpand: false,
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Filename",
            sortable: false,
            value: "name",
          },
          {
            text: "Proccessed Records",
            sortable: false,
            value: "processRecord",
          },
          {
            text: "Total Records",
            sortable: false,
            value: "total",
          },
          {
            text: "Status",
            align: "center",
            value: "status",
          },
          {
            text: "Date Uploaded",
            align: "status",
            value: "createdDate",
            formatter: (x) =>
              x ? this.formatDate(x, "MMM DD, YYYY h:mm:ss A") : null,
          },
          {
            text: "Actions",
            align: "center",
            value: "actions",
          },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    selectFile(file) {
      this.currentFile = file;
    },

    async getList() {
      this.table.loading = true;
      await this.$payment
        .get(`/verify-transactions`)
        .then((response) => {
          this.table.loading = false;
          const newArr = response.data.data;
          console.log(newArr);
          // console.log(newArr);
          this.table.data = newArr.verifyTransactions;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async upload() {
      this.submitted = true;
      const formData = new FormData();
      formData.append("file", this.currentFile);

      await this.$payment
        .post(`/verify-transactions`, formData)
        .then((response) => {
          const newArr = response.data;
          this.submitted = false;
          // this.$refs.fileInput.reset();
          this.fileUpload = null

          this.$store.dispatch("addSnackbarMessage", newArr.message);
          this.$store.dispatch("addSnackbar", true);

          if (newArr.status) {
            this.getList();
          }
          console.log(newArr);
          // console.log(newArr);
          // this.table.data = newArr;
          // this.table.loading = false;
        })
        .catch((e) => {
          // this.table.loading = false;
          console.log(e);
        });
      //         {
      //     "status": true,
      //     "message": "Successfully save",
      //     "data": {
      //         "transaction": {
      //             "name": "paymongo_jk2l2_inc._payouts_2023-07-25_1006am.csv",
      //             "status": "PROCESSING",
      //             "processRecord": 0,
      //             "total": 4852,
      //             "_id": 3,
      //             "createdDate": 1690792297248,
      //             "createdDateLabel": "2023-07-31",
      //             "createdDateTimeLabel": "2023-07-31 04:31:37 pm"
      //         }
      //     }
      // }
      // this.$papa.parse(this.currentFile, {
      //   skipEmptyLines: true,
      //   header: true,
      //   complete: (results) => {
      //     let napArray = results.data.map((item) => {
      //       return item["NAP Code"];
      //     });

      //     this.checkOlt(napArray);
      //     // console.log(napArray);
      //   },
      // });

      // console.log(ad);
    },

    viewRecord(item) {
      this.$router.push({
        name: "OnlinePaymentValidatorDetails",
        params: {
          id: item._id,
        },
      });
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
